import { render, staticRenderFns } from "./patientRecords.vue?vue&type=template&id=29651286&scoped=true&"
import script from "./patientRecords.vue?vue&type=script&lang=js&"
export * from "./patientRecords.vue?vue&type=script&lang=js&"
import style0 from "./patientRecords.vue?vue&type=style&index=0&id=29651286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29651286",
  null
  
)

export default component.exports